import Layout from "@components/layout/layout";

import ProfileSidebarDetails from "./profile-sidebar-details";

const ProfilePageSidebar = ({ profileId }: { profileId: number }) => {
  return (
    <Layout.Sidebar<string>
      tabs={[{ value: "details", title: "Details", active: true }]}
      onChangeTab={() => {}}
      sidebarExpandedUiPreferenceKey="profileSidebarExpanded"
    >
      <ProfileSidebarDetails profileId={profileId} />
    </Layout.Sidebar>
  );
};

export default ProfilePageSidebar;
